import { LOCALSTORE } from './types'

export const localAdd = (objName, value) => dispatch => {
    dispatch({
        type: LOCALSTORE,
        payload: value,
        objName: objName
    });
}
